module.exports = __webpack_public_path__ + "img/curug.4390494c.svg";